/* Error boundary — wraps MainLayout so render errors are visible instead of a blank screen */
// @ts-nocheck
import React from 'react';
import { clearToken } from '../../lib/auth';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[ErrorBoundary]', error, info);
    const msg = String(error?.message || error || '');
    const isChunk = /Failed to fetch dynamically imported module|Loading chunk \d+ failed|Importing a module script failed|error loading dynamically imported module/i.test(msg);
    if (isChunk) {
      try {
        if (!sessionStorage.getItem('dbtoolbox_chunk_reload')) {
          sessionStorage.setItem('dbtoolbox_chunk_reload', '1');
          const u = new URL(window.location.href);
          u.searchParams.set('_cb', String(Date.now()));
          window.location.replace(u.toString());
        }
      } catch (_) {}
    }
  }

  handleReset() {
    try { clearToken(); } catch (_) {}
    try { localStorage.removeItem('dbtoolbox_workspace_v1'); } catch (_) {}
    const msg = String(this.state.error?.message || this.state.error || '');
    const isChunk = /Failed to fetch dynamically imported module|Loading chunk \d+ failed|Importing a module script failed/i.test(msg);
    try { sessionStorage.removeItem('dbtoolbox_chunk_reload'); } catch (_) {}
    if (isChunk) {
      const u = new URL(window.location.href);
      u.searchParams.set('_cb', String(Date.now()));
      window.location.replace(u.toString());
      return;
    }
    window.location.reload();
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || 'Unknown error');
    const stack = String(this.state.error?.stack || '').split('\n').slice(0, 6).join('\n');
    return (
      <div style={{
        fontFamily: 'system-ui, sans-serif',
        padding: '2rem',
        maxWidth: '42rem',
        margin: '2rem auto',
        background: '#fff1f2',
        border: '1px solid #fca5a5',
        borderRadius: '8px',
        color: '#1f1f1f',
      }}>
        <h1 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem', color: '#b91c1c' }}>
          DB Tool Box — Error de UI
        </h1>
        <p style={{ fontSize: '0.85rem', marginBottom: '1rem' }}>
          Un componente falló al renderizar. Mensaje:
        </p>
        <pre style={{
          background: '#fff',
          border: '1px solid #fca5a5',
          borderRadius: '4px',
          padding: '0.75rem',
          fontSize: '0.75rem',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          marginBottom: '1rem',
        }}>
          {msg}
          {'\n\n'}
          {stack}
        </pre>
        <button
          onClick={() => this.handleReset()}
          style={{
            background: '#b91c1c',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '0.5rem 1.2rem',
            fontSize: '0.85rem',
            cursor: 'pointer',
          }}
        >
          Limpiar sesión y recargar
        </button>
        <button
          onClick={() => this.setState({ hasError: false, error: null, info: null })}
          style={{
            background: '#e5e7eb',
            color: '#1f1f1f',
            border: 'none',
            borderRadius: '4px',
            padding: '0.5rem 1.2rem',
            fontSize: '0.85rem',
            cursor: 'pointer',
            marginLeft: '0.5rem',
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }
}
